module.exports = __webpack_public_path__ + "static/media/img13.4fea55ae.jpg";